module.exports = __webpack_public_path__ + "static/media/mainSlide5.1d593ba1.jpg";